import { Divider } from '@hivebrite/design-system/Divider';

import ButtonLink from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ButtonLink';
import CheckboxSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/CheckboxSetting';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';

const ButtonContent = ({ index, item, number, onChange }) => (
  <>
    {number > 1 && (
      <>
        {index > 0 && <Divider mb={5} mt={2} />}
        <InputTitle
          boxProps={{ mb: 3 }}
          label={s__('Builder|Button %{number}').i__({
            number: `${index + 1}`,
          })}
          position="top"
        />
      </>
    )}
    <TextSetting
      item={item}
      onChange={onChange}
      settingKey="content"
      title={__('Content')}
    />
    <ButtonLink item={item} onChange={onChange} />
    <CheckboxSetting
      disabled={item.attributes?.buttonLink?.startsWith('mailto:')}
      item={item}
      settingKey="buttonLinkNewPage"
      title={__('Open link in a new tab')}
      onChange={onChange}
    />
  </>
);

export default ButtonContent;
